export interface MenuState {
    /** Whether the menu is currently open */
    open: boolean;
    /** Index of the currently highlighted navigable item, or -1 for none */
    highlightedIndex: number;
}

export const initialMenuState: MenuState = {
    open: false,
    highlightedIndex: -1,
};
